<template>
  <div>
    <div>
      <b-row>
        <b-col>
          <b-button-toolbar>
            <b-button-group>
              <b-button @click="Save()">{{ savebuttontext }}</b-button>
              <b-button v-if="!cancelHidden" @click="Cancel()">Avbryt</b-button>
            </b-button-group>

            <b-button-group class="mx-1">&nbsp;</b-button-group>
            <b-button-group>
              <b-button @click="exportAsExcel()" variant="outline-secondary">Exportera till Excel</b-button>

              <b-button @click="copyAll()" variant="outline-secondary">Kopiera allt</b-button>
              <!-- <b-button @click="insertFromClipboard()"
            ><b-icon-paste></b-icon-paste> Klistra in</b-button
          > -->
              <b-button @click="directPasteFromClipboard()" variant="outline-secondary">
                Klistra in
              </b-button>
              <b-button @click="removeAll()" variant="outline-secondary"> Rensa allt </b-button>
            </b-button-group>
            <b-button-group class="mx-1">&nbsp;</b-button-group>
            <b-button-group>
              <b-button @click="addRow()" variant="outline-secondary"> Lägg till rad </b-button>
              <b-button @click="InsertRow()" variant="outline-secondary"> Infoga rad</b-button>
              <b-button @click="delRow()" variant="outline-secondary">Ta bort rad</b-button>
            </b-button-group>
            <b-button-group class="mx-1">&nbsp;</b-button-group>
            <b-button-group>
              <b-checkbox v-model="hideEmptyCols" @change="toggeEmptyCols()">Dölj tomma kolumner</b-checkbox>
            </b-button-group>
          </b-button-toolbar>
        </b-col>
        <b-col cols="1">
          <textarea id="copyTo" style="height: 10px; width: 10px" />
        </b-col>
      </b-row>
    </div>
    <div>
      <vue-excel-editor v-if="wrkrecs" v-model="wrkrecs" ref="grid" :pageSize="70" :columnSuppress="true"
        :readonly="false" :autocomplete="true">
        <vue-excel-column v-for="(c, index) in GetCols()" :key="index" :field="c.field" :label="c.caption"
          :options="GetOptions(c)"></vue-excel-column>
      </vue-excel-editor>
    </div>
    <hr />
  </div>
</template>
<script>
// https://www.pika.dev/npm/vue-excel-editor
// https://github.com/cscan/vue-excel-editor
import VueExcelEditor from "vue-excel-editor";

// import VueExcelEditor from "vue-excel-editor";
import Vue from "vue";
Vue.use(VueExcelEditor);

//TODO: wrkrecs borde kopieras till ett lokalt objekt 

export default {
  components: [VueExcelEditor],
  name: "tableedit",
  props: {
    recs: Array, cols: Array, readonly: Boolean,
    savebuttontext: {
      type: String,
      default: "Spara"
    },
    cancelHidden: {
      type: Boolean,
      default: false
    }
  },

  data: () => {
    return {
      hideEmptyCols: false,
      wrkrecs: null
    };
  },
  created() {
    this.createWrkRecs()
  },
  watch: {
    recs: function () {
      this.createWrkRecs();
    }
  },
  methods: {
    createWrkRecs() {
      console.log(JSON.stringify(this.recs));
      if (this.recs)
        this.wrkrecs = JSON.parse(JSON.stringify(this.recs));
    },
    Save() {
      this.$emit('save', this.wrkrecs);
      // if(confirm("Vill du spara eventuella förändringar?")) {
      //     //alert('Spara ej implementerat');
      //     //this.$router.go(-1);
      //     this.$emit('save', this.wrkrecs);
      // }
    },
    Cancel() {
      this.$emit('cancel');
      // if(confirm("Vill du avbryta och slänga eventuella förändringar?")) {
      //     this.$emit('cancel');
      //     //this.$router.go(-1);
      // }
    },
    GetCols() {
      var r = this.cols;
      //r.forEach(x => x.readonly = this.readonly);
      return r;
    },
    GetOptions(c) {
      if (c.items) {
        return c.items.map(x => x.text);
      }
    },
    addRow() {
      this.$refs.grid.newRecord({});
    },
    InsertRow() {
      //var x = this.VueExcelEditor.selected;
      var rec = {};
      var r = this.$refs.grid.currentRowPos;
      this.wrkrecs.splice(r, 0, rec);
      //this.$refs.grid.newRecord(rec);
      //this.jsondata.push({});
    },
    delRow() {
      var r = this.$refs.grid.currentRowPos;
      this.$refs.grid.deleteRecord(r);
    },
    onSelect(x) {
      console.log(x);
    },
    oncellfocus(x) {
      console.log(x);
    },
    copyAll() {
      console.log(this.wrkrecs);

      var res = [];
      var headers = [];
      var headerTexts = [];
      this.$refs.grid.fields.forEach((f) => {
        headers.push(f.name);
        headerTexts.push(f.label);
      });
      res.push(headerTexts.join("\t"));
      this.wrkrecs.forEach((r) => {
        var newRow = [];
        headers.forEach((h) => {
          newRow.push(r[h]);
        });
        res.push(newRow.join("\t"));
      });

      var result = res.join("\n");
      console.log(result);

      var cto = document.getElementById("copyTo");
      cto.value = result;
      cto.select();
      cto.setSelectionRange(0, 999999);
      document.execCommand("copy");
    },
    insertFromClipboard() {
      var cto = document.getElementById("copyTo");
      this.insertFromText(cto.value);
    },

    insertFromText(txt) {
      //while (this.wrkrecs.length > 0) this.wrkrecs.shift();
      this.removeAll();


      var rows = txt.replaceAll('\r', '').split("\n");
      var headers = rows[0].split("\t");
      var headerColNames = [];
      headers.forEach((c) => {
        var cname = c.trim().toLowerCase();
        var field = this.cols.find(x => x.caption.toLowerCase() == cname);
        if (!field)
          field = this.cols.find(x => x.field.toLowerCase() == cname);

        if (field) {
          var colName = field.field;
          headerColNames.push(colName);
        } else {
          headerColNames.push("");
          console.log("field " + c + " not found.");
        }
      });



        // headers.forEach((c) => {
        //   var field = this.$refs.grid.fields.find(
        //     (x) => x.label.toLowerCase() == c.toLowerCase()
        //   );
        //   if (!field) {
        //     console.log("field " + c + " not found.");
        //   } else {
        //     var colName = field.name;
        //     headerColNames.push(colName);
        //   }
        // });
        for (var i = 1; i < rows.length; i++) {
          var newItem = {};
          var r = rows[i].split("\t");
          for (var c = 0; c < r.length; c++) {
            var col = headerColNames[c];
            if (col) newItem[col] = r[c];
          }
          this.wrkrecs.push(newItem);
        }
      },
        removeAll() {
        while(this.wrkrecs.length > 0) this.wrkrecs.shift();
    },
    directPasteFromClipboard() {
      navigator.clipboard.readText().then(this.insertFromText);
    },
    exportAsExcel() {
      const format = "xlsx";
      const exportSelectedOnly = false;
      const filename = "Transplanet-" + this.name;
      this.$refs.grid.exportTable(format, exportSelectedOnly, filename);
    },
    toggeEmptyCols() {
      //this.hideEmptyCols = !this.hideEmptyCols;
      if (this.hideEmptyCols) this.$refs.grid.columnSuppress();
      else {
        this.$refs.grid.fields.forEach((x) => (x.invisible = false));
      }
    },
  },
};
</script>

<style></style>